import { HubFeature } from "@ats/api/cm";
import { LocDefs, MapLocKeys } from "@cm/core/localization";

const dpRoot = 'Candidates|Summary|External IDs'

export type CandidateExternalIdsLoc = 
    | 'SPCandidateExternalIdsLabelDataProvider'
    | 'SPCandidateExternalIdsTitle'
    | 'SPCandidateExternalIdsButtonAddId'
    | 'SPCandidateExternalIdsButtonSetPreferred'
    | 'SPCandidateExternalIdsButtonEditId'
    | 'SPCandidateExternalIdsChangesSaved';

export const candidateExternalIdsLocs: LocDefs<CandidateExternalIdsLoc> = {
    SPCandidateExternalIdsLabelDataProvider: {
        defaultValue: 'Certmetrics',
        description: 'Label for name of data provider.',
        displayPath: `${dpRoot}|Data Provider`,
        displayType: 'Label',
        feature: HubFeature.Core,
        portal: 'SP',
    },
    SPCandidateExternalIdsTitle: {
        defaultValue: 'External IDs',
        description: 'Tab and page title for the external IDs page.',
        displayPath: `${dpRoot}|Title`,
        displayType: 'Title',
        feature: HubFeature.Core,
        portal: 'SP',
        legacyName: 'Core/Candidates.ExternalIds.Title.ExternalIds',
    },
    SPCandidateExternalIdsButtonAddId: {
        defaultValue: 'Add Candidate ID',
        description: 'Button to create a candidate ID.',
        displayPath: `${dpRoot}|Add ID`,
        displayType: 'Button',
        feature: HubFeature.CandidateProfileManageCandidateId,
        portal: 'SP',
        legacyName: 'CandidateProfile.ManageCandidateId/Candidate.ExternalIds.Button.AddID',
    },
    SPCandidateExternalIdsButtonSetPreferred: {
        defaultValue: 'Set Preferred',
        description: 'Button to set the preferred external ID.',
        displayPath: `${dpRoot}|Set Preferred`,
        displayType: 'Button',
        feature: HubFeature.Core,
        portal: 'SP',
        legacyName: 'Core/Candidate.ExternalIds.Button.SetPreferred',
    },
    SPCandidateExternalIdsButtonEditId: {
        defaultValue: 'Edit',
        description: 'Title for edit ID button',
        displayPath: `${dpRoot}|Edit ID`,
        displayType: 'Button',
        feature: HubFeature.CandidateProfileManageCandidateId,
        portal: 'SP',
        legacyName: 'CandidateProfile.ManageCandidateId/Candidate.ExternalIds.Button.EditID',
    },
    SPCandidateExternalIdsChangesSaved: {
        defaultValue: 'Changes saved',
        description: 'Label for name of data provider.',
        displayPath: `${dpRoot}|Changes Saved`,
        displayType: 'Notification',
        feature: HubFeature.Core,
        portal: 'SP',
        legacyName: 'Core/Candidate.ExternalIds.Notification.ChangesSaved',
    },
};

export const LOC_KEYS = MapLocKeys<CandidateExternalIdsLoc>(candidateExternalIdsLocs);
